<template>
	<div class="assess contains">
		<div class="content-tit">
			<h2>用户评价选项内容回复</h2>
		</div>

		<div class="content-main">
			<div class="flex-box">
				<div>
					<div class="box" v-for="(item,i) in Model">
						<div class="re-title">{{item.showId}}.{{item.name}}</div>
						<div v-if="item.updateAdd!=true">
							<div class="option" v-if="item.twoIsOpen">
								<div class="lable">是否开启二级回复：</div>
								<div class="flex-content">
									<el-switch v-model="item.childerIsOpen" active-text="开启"></el-switch>
								</div>
							</div>
							<div class="option" v-if="item.twoIsOpen">
								<div class="lable">自动回复内容</div>
								<div class="txt">
									<p v-for="(item2,j) in item.children">{{item2.showId}}.{{item2.name}}</p>
									<!-- <p>2.客服不够专业</p>
                       <p>3.客服态度不好</p>
                       <p>4.等待时间过长</p>
									<p>5.不想说</p>-->
								</div>
							</div>

							<div class="option">
								<div class="lable">是否开启自定内容回复：</div>
								<div class="flex-content">
									<el-switch v-model="item.isOpen" active-text="开启"></el-switch>
								</div>
							</div>
							<div class="option">
								<div class="lable">自动回复内容</div>
								<div class="txt">{{item.content}}</div>
							</div>
							<div class="option special">
								<el-button type="primary" @click="UpdateShow(item.id)">修改</el-button>
							</div>
						</div>

						<div v-if="item.updateAdd">
							<div class="option">
								<div class="lable">是否开启二级回复：</div>
								<div class="flex-content">
									<el-switch v-model="item.childerIsOpen" active-text="开启"></el-switch>
								</div>
							</div>

							<div class="option">
								<div class="lable">自动回复内容</div>
								<div class="number">
									<div class="no-1" v-for="(item1,j) in item.children">
										编号{{j+1}}：
										<span v-html="value" v-if="show"></span>
										<el-input type="input" v-model="item1.name"></el-input>
										<a class="add" @click="UpdateCommentBase(item1.id,item1.name)">{{text}}</a>
										<a class="delete" @click="delete_id(item1.id,item.id)">删除</a>
									</div>

									<div class="no-1">
										编号{{item.maxCount}}：
										<span v-html="value2" v-if="show2"></span>
										<el-input type="input" v-model="CommentBase.Name" v-if="!show2"></el-input>
										<a class="add" @click="Add(item.id)">{{text2}}</a>
										<!-- <a class="delete" @click="delete_id(item1.id)">删除</a> -->
									</div>
								</div>
							</div>
							<div class="option">
								<div class="lable">是否开启自定内容回复：</div>
								<div class="flex-content">
									<el-switch v-model="item.isOpen" active-text="开启"></el-switch>
								</div>
							</div>
							<div class="option">
								<div class="lable">自动回复内容</div>
								<div class="flex-content">
									<el-input type="input" v-model="item.content" style="margin-left:10px"></el-input>
								</div>
							</div>
							<div class="option special">
								<el-button @click="Clear(item.id)">取消</el-button>
								<el-button type="primary" @click="Update(item.id,item.content,item.isOpen,item.isTrue,item.childerIsOpen)">保存</el-button>
							</div>
						</div>
					</div>

                 <!-- <div class="option">
                   <div class="lable">自动回复内容</div>
                   <div class="number">
                       <div class="no-1" v-for="(item1,j) in item.children">编号{{j+1}}：
                         <span v-html="value" v-if="show"></span>
                         <el-input   type="input" v-model="item1.name"  ></el-input>
                         <a class="add" @click="UpdateCommentBase(item1.id,item1.name)">{{text}}</a>
                          <a class="delete" @click="delete_id(item1.id,item.id)">删除</a>
                       </div>
                        
                      <div class="no-1">编号{{item.maxCount}}：
                         <span v-html="value2" v-if="show2"></span>
                         <el-input   type="input" v-model="CommentBase.Name" v-if="!show2" ></el-input>
                         <a class="add" @click="Add(item.id)">{{text2}}</a>
                           <!-- <a class="delete" @click="delete_id(item1.id)">删除</a> -->
                      </div>
                   </div>
                 </div> -->
                 <!-- <div class="option">
                   <div class="lable">是否开启自定内容回复：</div>
                   <div class="flex-content">
                     <el-switch
                       v-model="item.isOpen"
                       active-text="开启">
                     </el-switch>
                   </div>
                 </div> -->
                 <!-- <div class="option">
                   <div class="lable">自动回复内容</div>
                   <div class="flex-content">
                     <el-input   type="textarea" v-model="item.content" style="margin-left:10px"></el-input>
                   </div>
                 </div> -->
                 <!-- <div class="option special">
                   <el-button @click="Clear(item.id)">取消</el-button>
                   <el-button type="primary" @click="Update(item.id,item.content,item.isOpen,item.isTrue)">保存</el-button>
                 </div> -->

                 </div>   

                </div>
                
                <!-- <div class="box">
                   <div class="re-title">2.一般</div>
                   <div class="option">
                     <div class="lable">是否开启二级回复：</div>
                     <div class="flex-content">
                       <el-switch
                         v-model="value1"
                         active-text="开启">
                       </el-switch>
                     </div>
                   </div>
                   <div class="option">
                     <div class="lable">自动回复内容</div>
                     <div class="txt">
                       <p>1.没有解决实际问题</p>
                       <p>2.客服不够专业</p>
                       <p>3.客服态度不好</p>
                       <p>4.等待时间过长</p>
                       <p>5.不想说</p>
                     </div>
                   </div>
                   <div class="option">
                    <div class="lable">是否开启自定内容回复：</div>
                    <div class="flex-content">
                      <el-switch
                        v-model="value1"
                        active-text="开启">
                      </el-switch>
                    </div>
                  </div>
                   <div class="option">
                    <div class="lable">自动回复内容</div>
                    <div class="txt">感谢您对我们提出的宝贵意见，我们会加强管理学习~</div>
                  </div>
                   <div class="option special">
                     <el-button type="primary">修改</el-button>
                   </div>
               </div>

               <div class="box">
                 <div class="re-title">3.不满意</div>
                 <div class="option">
                   <div class="lable">是否开启二级回复：</div>
                   <div class="flex-content">
                     <el-switch
                       v-model="value1"
                       active-text="开启">
                     </el-switch>
                   </div>
                 </div>

                 <div class="option">
                   <div class="lable">自动回复内容</div>
                   <div class="number">
                       <div class="no-1">编号1：
                         <span v-html="value" v-if="show"></span>
                         <el-input v-model="value" v-if="!show"></el-input>
                         <a class="add" @click="add">{{text}}</a>
                       </div>
                      <div class="no-1">编号2：
                         <span v-html="value2" v-if="show2"></span>
                         <el-input v-model="value2" v-if="!show2"></el-input>
                         <a class="add" @click="add2">{{text2}}</a>
                      </div>
                   </div>
                 </div>
                 <div class="option">
                   <div class="lable">是否开启自定内容回复：</div>
                   <div class="flex-content">
                     <el-switch
                       v-model="value1"
                       active-text="开启">
                     </el-switch>
                   </div>
                 </div>
                 <div class="option">
                   <div class="lable">自动回复内容</div>
                   <div class="flex-content">
                     <el-input ></el-input>
                   </div>
                 </div>
                 <div class="option special">
                   <el-button>取消</el-button>
                   <el-button type="primary">保存</el-button>
                 </div>
					</div>-->
				</div>
			</div>

</template>

<script>
import { Base64 } from 'js-base64'
export default {
	name: 'assess',
	props: [],
	data() {
		return {
			show: false,
			show2: false,
			value1: '',
			value2: '',
			text: '修改',
			text2: '添加',
			value: '',
			Model: [{}],
			//添加
			CommentBase: {
				ShowId: 0,
				Name: '',
				Content: '',
				ParentId: 0,
				IsOpen: 0
			},
			CommentBaseUpdate: {
				Id: 0,
				Content: '',
				Name: 'm '
			}
		}
	},
	watch: {},
	mounted: function() {
		this.Show()
	},
	methods: {
		// add(){
		//   console.log(this.value)
		//   if(this.text=='修改'){
		//     this.show=!this.show
		//     this.text='添加'
		//     return false
		//   }
		//   if(this.value!=''){
		//     this.value=this.value
		//     this.show=!this.show
		//     this.text='修改'
		//   }

		// },
		// add2(){
		//   console.log(this.value2)
		//   if(this.text2=='修改'){
		//     this.show2=!this.show2
		//     this.text2='添加'
		//     return false
		//   }
		//   if(this.value2!=''){
		//     this.value2=this.value2
		//     this.show2=!this.show2
		//     this.text2='修改'
		//   }
		// },
		Show() {
			let $this = this
			this.axios
				.get('Comment/L_List', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
						console.log("Xxx")
						console.log(data)

					$this.Model = data.data

					//  $this.Model.forEach(element => {
					//    element.UpdateAdd=false;
					//  });
				})
		},
		//添加
		Add(Id) {
			let $this = this
			$this.Model.forEach(element => {
				if (element.id == Id) {
					$this.CommentBase.ShowId = element.maxCount
					$this.CommentBase.Content = element.content
					$this.CommentBase.ParentId = Id
					$this.CommentBase.IsOpen = element.isTrue
				}
			})

			this.axios
				.post('Comment/AddCommentBase', $this.CommentBase, {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					if (data.data.message == '成功') {
						// alert(data.data.message)
						// $this.$message()
						$this.Show()
						$this.CommentBase.Name = ''
					} else {
					 
						$this.$message.error(data.data.message)
					}
				})
		},
		Update(Id, Content, IsOpen, IsOpen1,childerIsOpen) {
			var IsOpen11 = 0
			var IsOpen21 = 0
			if (IsOpen) {
				IsOpen11 = 1
			}
			if (IsOpen1) {
				IsOpen21 = 1
			}

			let $this = this
			this.axios
				.post(
					'Comment/Update?id=' +
						Id +
						'&Content=' +
						Content +
						'&IsOpen=' +
						IsOpen11
						+'&childerIsOpen='+
						childerIsOpen,
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					if (data.data.message == '成功') {
						//  alert(data.data.message)
						//   $this.Show();
						$this.axios
							.post(
								'Comment/Update_son?ParentId=' +
									Id +
									'&IsOpen=' +
									IsOpen11 +
									'&Content=' +
									Content,
								{
									headers: {
										'Content-Type': 'application/json'
									}
								}
							)
							.then(function(data1) {
								if (data1.data.message == '成功') {
								 
									$this.Show()
								} else {
									$this.$message.error(data1.data.message)
								 
								}
							})
					} else {
						$this.$message.error(data.data.message)
					}
				})
		},
		UpdateCommentBase(Id, Content) {
			let $this = this
			this.axios
				.post(
					'Comment/UpdateCommentBase?Id=' +
						Id +
						'&Content=' +
						Content,
					{
						headers: {
							'Content-Type': 'application/json' 
						}
					}
				)
				.then(function(data) {
					if (data.data.message == '成功') {
						// alert(data.data.message)
						$this.Show()
					} else {
						$this.$message.error(data.data.message)
					}
				})
		},
		UpdateShow(id) {
			let $this = this
			$this.Model.forEach(element => {
				if (element.id == id) {
					element.updateAdd = true
				}
			})

			//   $this.Model.forEach(element => {
			//    element.UpdateAdd=true;
			//  });
		},
		Clear(id) {
			let $this = this
			$this.Model.forEach(element => {
				if (element.id == id) {
					element.updateAdd = false
					$this.CommentBase.Name = ''
				}
			})
		},
		//删除
		delete_id(id, paraId) {
			let $this = this
			this.$confirm('是否删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					$this.axios
						.post('Comment/Delete_son?Id=' + id, {
							headers: {
								'Content-Type': 'application/json'
							}
						})
						.then(function(data) {
							if (data.data.message == '成功') {
								$this.$message({
									type: 'success',
									message: '删除成功!'
								})

								$this.axios
									.post(
										'Comment/Update_ShowId?parentId=' +
											paraId,
										{
											headers: {
												'Content-Type':
													'application/json'
											}
										}
									)
									.then(function(data1) {
										$this.Show()
									})
							} else {
								$this.$message.error(data1.data.message)
							}
						})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		}
	}
}
</script>

<style scoped>
.delete {
	color: red;
	/* color: #65A9E8; */
	text-decoration: underline;
}
.content-tit {
	line-height: 40px;
	padding-bottom: 5px;
	padding-top: 20px;
}
.content-tit h2 {
	font-size: 24px;
	line-height: 30px;
	font-weight: normal;
}
.flex-box {
	width: 100%;
	padding-top: 30px;
}
.box {
	width: 75%;
	padding: 30px;
	background-color: #f6f7f9;
	margin-bottom: 25px;
}
.re-title {
	font-size: 18px;
	font-weight: bolder;
	margin-bottom: 10px;
}
.assess .option {
	display: flex;
	display: -webkit-flex;
	align-items: flex-start;
	justify-content: flex-start;
	padding: 0 0 10px 0;
}
.assess .option.special {
	width: 540px;
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: flex-end;
	padding: 10px 0;
}
.assess .lable {
	line-height: 32px;
}
.assess .flex-content {
	line-height: 32px;
	width: 400px;
}
.assess .txt {
	line-height: 32px;
	color: #999;
}
.assess .number {
	margin-left: 20px;
	line-height: 32px;
}
.assess .number span {
	display: inline-block;
	margin-right: 20px;
	color: #999;
}
.assess .number .no-1 {
	margin-bottom: 15px;
}
.assess .add {
	color: #65a9e8;
	text-decoration: underline;
}
</style>
<style>
  .assess .el-textarea__inner{
    background-color:#fff;
    width:400px;
    height:75px;
  }
  .assess .el-input__inner{
    width:500px;
    background-color:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/setting/assess.vue